export interface ActivityLog {
  activityType: string;
  createdAt: Date;
  message: string;
  tip: string;
  id: string;
  name: string;
  logoUrl: string;
}

export interface ActivityLogObject {
  events: ActivityLog[];
  nextKey: string;
}
